<template>
  <van-overlay :show="loading" class="jun-loading">
    <van-loading />
  </van-overlay>
</template>
<script>
import { Overlay, Loading } from 'vant'
export default {
  components: {
    [Overlay.name]: Overlay,
    [Loading.name]: Loading
  },
  data() {
    return {
      loading: false
    }
  }
}
</script>
<style lang="scss">
.jun-loading {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/base/jun-loading/loading.vue